import Toastify from 'toastify-js';

export default function (message, type, options) {

  let toasterStatus = type || 'success';

  let tostifyOptions = {
    text: message,
    className: `${toasterStatus} unimy-toast`,
    duration: 3000,
    // destination: "https://github.com/apvarun/toastify-js",
    // newWindow: true,
    close: true,
    gravity: "top", // `top` or `bottom`
    position: "right", // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    style: {
      background: '#000',
    },
    onClick: function () { } // Callback after click
  }

  return Toastify(tostifyOptions).showToast();

}